import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * The item drawer's "Saved Item instructions" cache.
 *
 * A staff member taking phone orders types the same handful of notes all day
 * ("no onions", "extra spicy"), so the drawer lets them star one and re-apply
 * it as a chip later. The cache is deduped and holds the **20 most recent,
 * newest first** — the original's own numbers.
 *
 * Only the star is staff-gated; once the cache has entries the chip row renders
 * for every customer, which is the original's behaviour and not an oversight.
 */
interface InstructionsState {
  saved: string[];
}

const MAX_SAVED = 20;

const initialState: InstructionsState = { saved: [] };

const instructionsSlice = createSlice({
  name: "instructions",
  initialState,
  reducers: {
    saveItemInstructionsToCache(state, action: PayloadAction<string>) {
      const value = action.payload.trim();
      if (!value) return;
      state.saved = [
        ...new Set([value, ...state.saved]),
      ].slice(0, MAX_SAVED);
    },
    removeItemInstructionsFromCache(state, action: PayloadAction<string>) {
      state.saved = state.saved.filter((entry) => entry !== action.payload);
    },
  },
});

export const {
  saveItemInstructionsToCache,
  removeItemInstructionsFromCache,
} = instructionsSlice.actions;

export default instructionsSlice.reducer;
